  $(document).ready(function() {
    $('.template-page-waiting_list a[href^="#"]').on('click', function(event) {
      // Get the target element from the href attribute
      var target = $($(this).attr('href'));

      // Check if the target element exists on the page
      if (target.length) {
        // Prevent the default anchor jump
        event.preventDefault();

        // Animate the scroll to the target element
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 800); // 800 is the scroll speed in milliseconds
      }
    });
  });
$(document).on('click', '.reviewcstm', function() {
 
  $('html,body').animate({
    scrollTop: $("#shopify-block-judge_me_reviews_all_reviews_page_NdhQyT ").offset().top},
  'slow');
})

$(document).on('click', 'button.upgrade-button', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var that = $(this);
  if (that.hasClass('propage') && $(this).attr('disabled')) {              
    return;
  }
  const cartLink = document.querySelector('#cart-icon-bubble');
  $(this).find('span').hide();
  $(this).find('.loading__spinner').removeClass('hidden');
  
  var id = $(this).attr('dataid');
  var sellingplan = $(this).attr('selling_plan');
  var items = 
    {
     id: id,
     quantity: 1
    };

    if (sellingplan) {
      items = {
          id: id,
          quantity: 1,
          selling_plan: sellingplan
        };
    }

  //   $.ajax({
  // type: 'POST',
  // url: '/cart/clear.js',
  // dataType: 'json',
  // success: function(cart) {
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: items,
      success: function(res) {
          $.ajax({
            type: 'GET',
            url: `${routes.cart_url}?view=fullcartdrawer`,
            success: function(htm) {
              $('cart-drawer ').removeClass('is-empty');
              $('cart-drawer ').html(htm);
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');
              $('.modal').removeClass('is-visible');
            },
            error: function(err) {
              console.log(err);
              that.find('span').show();
              that.find('.loading__spinner').addClass('hidden');               
            }
          });          

        jQuery.getJSON('/cart.js', function(cart) {
          if ($('.cart-count-bubble')[0]) {
            $('.cart-count-bubble span').html(cart.item_count);
          } else {
            var dt = '<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span> </div>'
            $('#cart-icon-bubble').append(dt);
          }
          cartLink.click();
        });        
      },
      error: function(err) {
        console.log(err);   
        if (err && err.responseJSON && err.responseJSON.message) {
          $('.error_cart_upsell').html(err.responseJSON.message);
        }      
        that.find('span').show();
        that.find('.loading__spinner').addClass('hidden');            
      }
  });
  // },
  // error: function(xhr, status, error) {
  //   // Code to run if there is an error.
  //   console.error('Error clearing cart:', error);
  //       that.find('span').show();
  //       that.find('.loading__spinner').addClass('hidden'); 
  // }
// });



});

$(document).ready(function() {

  $('li.block_type_tab').click(function() {
    $('li.block_type_tab').removeClass('active');
    $(this).addClass('active');
    var btype = $(this).attr('block_type');
    $('.carousel-before-after-wrapper.owl-carousel').hide();
    $('.blktype__'+btype).fadeIn();
  })
  $('button.btn_tab_treatment').click(function() {
    $('button.btn_tab_treatment').removeClass('active');
    $('.btn_tabs_active_status li').removeClass('active');
    
    $(this).addClass('active');
    var btype = $(this).attr('atr');
    $('.btn_tabs_active_status li[atr="'+btype+'"]').addClass('active');
    $('.treatment-benefits__block').hide();
    $('.block_type_'+btype).fadeIn();
  })

  $('button.btn_tab_how_to_use').click(function() {
    $('button.btn_tab_how_to_use').removeClass('active');
    $(this).addClass('active');
    var btype = $(this).attr('atr');
    $('.cc-htu-process-step').hide();
    $('.step_type_'+btype).fadeIn();

    $('.cc-how-to-use-results video').hide();
    $('.cc-how-to-use-results video[atr="'+btype+'"]').show();
  })

  $('button.btn_tab_ingredients').click(function() {
    $('button.btn_tab_ingredients').removeClass('active');
    $(this).addClass('active');
    var btype = $(this).attr('atr');
    $('.cc-key-ingred-icon-content').hide();
    $('.in_step_type_'+btype).fadeIn();
    $('.cc-key-ingrd-icon-content.e_tab').hide();
    $('.cc-key-ingrd-icon-content.e_tab[atr="'+btype+'"]').fadeIn();
  })


  $('.video_poster_img').mouseover(function() {
    $('.video_poster_img').removeClass('hideback');
    $('.playbtn').show();
    $('.videin').each(function() {
        $(this).get(0).pause();
    });
    $(this).parents('.ugc-video-item').find('.videin')[0].play();
    $(this).parents('.ugc-video-item').find('.playbtn').hide();
    
    $(this).addClass('hideback');
  });

  $(document).on('click', '.product-media-modal__toggle',  function() {    
    $('.cc-how-to-use-results').find('video')[0].play();
  });

  $(document).on('click', 'button.quantity__button',  function() {  
    setTimeout(() => {
    var qty = $(this).siblings('.quantity__input').val();
    $(this).siblings('.quantity__input').val(qty);      
    $(this).siblings('.quantity__input').attr('value', qty);      
      console.log(qty)
    }, 50);
  });

  

  $('.Faq__Item').click(function() {
    var v = $(this).attr('aria-expanded');
    if (v == 'true') {
      $(this).attr('aria-expanded', 'false');
    } else {
      $(this).attr('aria-expanded', 'true');      
    }
    $(this).find('.Faq__AnswerWrapper').slideToggle();
  });

  $('.carousel-before-after-wrapper.owl-carousel').owlCarousel({        
    nav: true,
    dots: true,
    loop: true,
    items: 1,
    autoplay: true,
    onInitialized: startProgressBar,
    onTranslate: resetProgressBar,
    onTranslated: startProgressBar
  });

  $('.owl-dots button').html('<div class="slide-progress"></div>');
  $('.ugc-videos-inner.owl-carousel').owlCarousel({        
    nav: true,
    dots: true,
    items: 4,
    margin: 15,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            stagePadding: 30
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
  });

function startProgressBar()
{
  // apply keyframe animation
  $(".owl-dot.active .slide-progress").css({
    width: "100%",
    transition: "width 5000ms"
  });
}

function resetProgressBar()
{
  $(".owl-dot .slide-progress").css({
    width: 0,
    transition: "width 0ms"
  });
}

  $('.owl-nav button').html('<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none"> <ellipse opacity="1" cx="16.8398" cy="16.5" rx="16" ry="16" transform="rotate(-180 16.8398 16.5)" fill="#242424"/> <path d="M17.8398 20.5L13.8398 16.5L17.8398 12.5" stroke="#ffffff" stroke-width="1.5"/> </svg>');  
});
